module.exports = __webpack_public_path__ + "img/swine.07a210fa.svg";